<template>
  <section class="success">
    <div class="success-area">
      <span class="success-area-title">{{message}}</span>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      message: ''
    }
  },
  mounted() {
    var message_type = this.$route.params.type;
    if('success' == message_type) {
      this.message = '支付完成，是否成功报名以管理员最终确认为准';
    } else if('cancel' == message_type) {
      this.message = '已取消支付';
    } else {
      this.message = '未知类型';
    }
  }
}
</script>
<style lang="less" scoped>
.success{
  width: 100%;
  &-area{
    display: flex;
    flex-direction: column;
    align-items: center;
    border:1px solid rgba(223, 228, 233, 1);
    background: #F2F6FA;
    margin-bottom: 50px;
    &-title{
      margin: 40px;
      font-size:33px;
      font-weight:400;
      color:rgba(57,149,255,1);
    }
  }
}
</style>
